import {configureStore} from '@reduxjs/toolkit';
import rootReducer from './reducers/rootReducer';
import {baseAPI} from '../services/BaseAPI';

export const setupStore = () => {
    return configureStore({
        reducer: rootReducer,
        // injectEndpoints extends the same API instance for every service.
        middleware: getDefaultMiddleware => getDefaultMiddleware().concat(baseAPI.middleware),
    });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
